// src/pages/WhatWeDoPage.js
import React, { useState } from 'react';
import './WhatWeDoPage.css';
import ServiceModal from '../components/ServiceModal';

// Import all images
import heroCleaningCourt from '../assets/images/hero-cleaning-court.png';
import brandingWhiteFontNoLogo from '../assets/images/branding-vanguard-white-font-no-logo.png';
import hotels from '../assets/images/hotels.jpg';
import commercial from '../assets/images/commercial.jpg';
import school from '../assets/images/school.jpg';
import venues from '../assets/images/venues.jpg';
import logoBlueWhite from '../assets/images/logo-vanguard-blue-white.png';

// Service images
import pressureWashingImg from '../assets/images/exterior.png';
import paintingImg from '../assets/images/painting.png';
import gardeningImg from '../assets/images/gardening.png';
import wasteImg from '../assets/images/waste.png';
import handyImg from '../assets/images/handy.jpg';
import waterproofingImg from '../assets/images/water-proofing.png';

// Pop images for modal
import pressureWashingPop from '../assets/images/pressurewashing_pop.png';
import paintingPop from '../assets/images/painting_pop.png';
import gardeningPop from '../assets/images/gardening_pop.png';
import wasteManagementPop from '../assets/images/waste_management_pop.png';
import generalMaintenancePop from '../assets/images/general_maintenance_pop.png';
import waterproofingPop from '../assets/images/waterproofing_pop.png';

const WhatWeDoPage = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Service data mapping for modal
  const servicesData = {
    'Pressure Washing': {
      id: 6,
      title: 'PRESSURE WASHING',
      carouselImage: pressureWashingImg,
      heroImage: pressureWashingPop,
      heroText: 'High-pressure cleaning for exterior surfaces including roofs, driveways, pathways, building facades, loading docks, car parks, bins areas, and sandstone, concrete or brick surfaces.',
      activitiesList: [
        'Assessment before job',
        'Surface protection & setup',
        'Cleaning process',
        'Roof cleaning:',
        'Driveways & pathways:',
        'Facades & car parks:',
        'Waste recovery & final care:'
      ],
      advantagesList: [
        'High-quality products & cutting-edge machinery',
        'Organisation and environmental care',
        'Surface care and protection'
      ],
      processList: ['Protect', 'Pre-treat', 'Wash', 'Rinse', 'Recover', 'Inspect', 'Report']
    },
    'Painting': {
      id: 1,
      title: 'PAINTING',
      carouselImage: paintingImg,
      heroImage: paintingPop,
      heroText: 'Interior and exterior painting for commercial and residential buildings, including touch-ups, full repaints, protective coatings, and line marking',
      activitiesList: [
        'Colour and coating consultation.',
        'Surface preparation (sanding, patching, priming).',
        'Application by licensed painters (brush/roller/spray).',
        'Multi-coat process with drying time management.',
        'Final inspection and touch-ups.'
      ],
      advantagesList: [
        'Minimal disruption to tenants',
        'Durable finish',
        'Professional painters',
        'Quality material'
      ],
      processList: ['Quote', 'Prepare', 'Paint', 'Cleaning', 'Inspect', 'Handover']
    },
    'Gardening & Tree Trimming': {
      id: 2,
      title: 'GARDENING',
      carouselImage: gardeningImg,
      heroImage: gardeningPop,
      heroText: 'Routine and corrective garden maintenance for commercial and residential properties, including planting, weeding, mulching, fertilising, tree trimming and pruning.',
      activitiesList: [
        'Site-specific garden plan creation.',
        'Scheduled visits (weekly/fortnightly/monthly).',
        'Hand weeding and mechanical edging.',
        'Mulching and slow-release fertilising.',
        'Green waste removal and composting.'
      ],
      advantagesList: [
        'Curb appeal',
        'Plant health',
        'Reduced water usage',
        'Up level appearance',
        'Safer environment'
      ],
      processList: ['Assess', 'Plan', 'Maintain', 'Dispose', 'Report']
    },
    'Waste Management': {
      id: 4,
      title: 'TREE TRIMMING',
      carouselImage: wasteImg,
      heroImage: wasteManagementPop,
      heroText: 'Integrated collection, sorting, and disposal of general waste, recycling, organics, and hazardous materials from commercial and residential buildings.',
      activitiesList: [
        'Waste audit and bin flow analysis.',
        'Right-sizing bins and scheduling pickups.',
        'Training cleaning staff on segregation.',
        'Partnering with licensed recyclers.',
        'Monthly waste diversion reports.'
      ],
      advantagesList: [
        'Lower landfill costs',
        'Compliance with council rules',
        'ESG reporting'
      ],
      processList: ['Audit', 'Optimise', 'Collect', 'Recycle', 'Report']
    },
    'General Maintenance': {
      id: 5,
      title: 'GENERAL MAINTENANCE',
      carouselImage: handyImg,
      heroImage: generalMaintenancePop,
      heroText: 'Ongoing repair and upkeep of building elements and equipment, including doors, windows, locks, taps, lights, shelving, handrails, and minor plaster or tile repairs.',
      activitiesList: [
        'Planned preventative inspections (monthly/quarterly).',
        'Mobile technicians dispatched with job-specific kits.',
        'On-site diagnosis and repair (first-time fix target).',
        'Parts replacement using approved suppliers.',
        'Post-repair testing and site clean-up.',
        'Digital sign-off with notes.'
      ],
      advantagesList: [
        'Reduced downtime',
        'Extended asset life',
        'Single point of accountability',
        'No need for multiple trades'
      ],
      processList: ['Take request', 'Dispatch', 'Repair', 'Test', 'Close', 'Report']
    },
    'Waterproofing': {
      id: 3,
      title: 'WATERPROOFING',
      carouselImage: waterproofingImg,
      heroImage: waterproofingPop,
      heroText: 'Application of liquid membranes, sealants, and sheet systems to prevent water ingress in roofs, basements, bathrooms, and balconies.',
      activitiesList: [
        'Moisture testing and substrate preparation.',
        'Repair of cracks and joints.',
        'Application of primer and waterproofing membrane (spray/roll/trowel).',
        'Curing and flood testing.',
        'Final sealing and warranty issuance.'
      ],
      advantagesList: [
        'Prevents structural damage',
        'Prevents mould',
        'Avoid tenant disruption',
        'Creates cleaner and safer environments'
      ],
      processList: ['Diagnose', 'Prepare', 'Apply', 'Test', 'Guarantee']
    }
  };

  const handleCardClick = (serviceName) => {
    const service = servicesData[serviceName];
    if (service) {
      setSelectedService(service);
      document.body.style.overflow = 'hidden';
    }
  };

  const closeModal = () => {
    setSelectedService(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="what-we-do-page">
      {/* 1. Hero Section */}
      <section className="wwd-hero">
        <div className="container">
          <div className="wwd-hero-grid">
            <div className="wwd-hero-left">
              <img src={heroCleaningCourt} alt="Cleaning Court" className="wwd-hero-image" />
            </div>
            <div className="wwd-hero-right">
              <div className="wwd-hero-text-wrapper">
                <h1 className="wwd-hero-title">
                  A structured approach to<br />
                  external grounds, common<br />
                  areas and building appearance.<br />
                </h1>
              </div>
              <div className="wwd-hero-logo-wrapper">
                <img src={brandingWhiteFontNoLogo} alt="Vanguard" className="wwd-hero-logo" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Categories Grid */}
      <section className="wwd-categories">
        <div className="container">
          <div className="categories-grid">
            <div className="category-item">
              <h3 className="category-title">Hotels</h3>
              <div className="category-image-wrapper">
                <img src={hotels} alt="Hotels" className="category-image" />
              </div>
            </div>
            <div className="category-item">
              <h3 className="category-title">Commercial</h3>
              <div className="category-image-wrapper">
                <img src={commercial} alt="Commercial" className="category-image" />
              </div>
            </div>
            <div className="category-item">
              <h3 className="category-title">School</h3>
              <div className="category-image-wrapper">
                <img src={school} alt="School" className="category-image" />
              </div>
            </div>
            <div className="category-item">
              <h3 className="category-title">Venues</h3>
              <div className="category-image-wrapper">
                <img src={venues} alt="Venues" className="category-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Blue Banner Section */}
      <section className="wwd-banner">
        <div className="container">
          <div className="banner-grid">
            <div className="banner-text">
              <p>
                Vanguard Facilities Services Group operates as a<br />
                single-point facilities provider, reducing the need to<br />
                coordinate multiple contractors while maintaining<br />
                high trade standards across all services.
              </p>
            </div>
            <div className="banner-logo">
              <img src={logoBlueWhite} alt="Vanguard" />
            </div>
          </div>
        </div>
      </section>

      {/* 4. Services Section with Clickable Cards */}
      <section className="wwd-services">
        <div className="container">
          {/* Left-aligned services */}
          <div 
            className="service-row left clickable"
            onClick={() => handleCardClick('Pressure Washing')}
          >
            <div className="service-image-container">
              <img src={pressureWashingImg} alt="Pressure Washing" className="service-image" />
            </div>
            <div className="service-line-container">
              <div className="service-line"></div>
            </div>
            <div className="service-text right-aligned">
              <h2>Pressure Washing</h2>
            </div>
          </div>

          <div 
            className="service-row left clickable"
            onClick={() => handleCardClick('Painting')}
          >
            <div className="service-image-container">
              <img src={paintingImg} alt="Painting" className="service-image" />
            </div>
            <div className="service-line-container">
              <div className="service-line"></div>
            </div>
            <div className="service-text right-aligned">
              <h2>Painting</h2>
            </div>
          </div>

          <div 
            className="service-row left clickable"
            onClick={() => handleCardClick('Gardening & Tree Trimming')}
          >
            <div className="service-image-container">
              <img src={gardeningImg} alt="Gardening & Tree Trimming" className="service-image" />
            </div>
            <div className="service-line-container">
              <div className="service-line"></div>
            </div>
            <div className="service-text right-aligned">
              <h2>Gardening &<br/>Tree Trimming</h2>
            </div>
          </div>

          {/* Right-aligned services */}
          <div 
            className="service-row right clickable"
            onClick={() => handleCardClick('Waste Management')}
          >
            <div className="service-text left-aligned">
              <h2>Waste Management</h2>
            </div>
            <div className="service-line-container">
              <div className="service-line"></div>
            </div>
            <div className="service-image-container">
              <img src={wasteImg} alt="Waste Management" className="service-image" />
            </div>
          </div>

          <div 
            className="service-row right clickable"
            onClick={() => handleCardClick('General Maintenance')}
          >
            <div className="service-text left-aligned">
              <h2>General Maintenance</h2>
            </div>
            <div className="service-line-container">
              <div className="service-line"></div>
            </div>
            <div className="service-image-container">
              <img src={handyImg} alt="General Maintenance" className="service-image" />
            </div>
          </div>

          <div 
            className="service-row right clickable"
            onClick={() => handleCardClick('Waterproofing')}
          >
            <div className="service-text left-aligned">
              <h2>Waterproofing</h2>
            </div>
            <div className="service-line-container">  
              <div className="service-line"></div>
            </div>
            <div className="service-image-container">
              <img src={waterproofingImg} alt="Waterproofing" className="service-image" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. Centered Quote */}
      <section className="wwd-quote">
        <div className="container">
          <p className="centered-quote">
            "Every service is delivered with precision, professionalism, and attention to detail. From<br />
            routine maintenance to specialised care, our people ensure that every asset reflects the<br />
            highest standards."
          </p>
        </div>
      </section>

      {/* 6. Values Section */}
      <section className="wwd-values">
        <div className="container">
          <div className="values-grid">
            <div className="values-list">
              <ul>
                <li>Scalable to each asset's needs</li>
                <li>Flexible service scope</li>
                <li>Adjustable service frequency</li>
                <li>Workforce sized to the task</li>
                <li>Budget-aligned solutions</li>
                <li>Reliable and efficient delivery</li>
                <li>Short or long-term support</li>
                <li>Professional service standards</li>
              </ul>
            </div>
            <div className="values-text-right">
              <p>
                Either when a small group or a full on-site<br />
                team is needed, we adjust staffing to<br />
                match each client's scope, budget, and<br />
                timeline. Ensuring efficient, reliable service<br />
                at all times.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedService && (
        <ServiceModal service={selectedService} onClose={closeModal} />
      )}
    </div>
  );
};

export default WhatWeDoPage;